import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const CloseIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M19.8232 5.23742L13.0606 12L19.8232 18.7625L18.7625 19.8232L12 13.0606L5.23742 19.8232L4.17676 18.7625L10.9393 12L4.17676 5.23742L5.23742 4.17676L12 10.9393L18.7625 4.17676L19.8232 5.23742Z", fill: "currentColor" }));
//# sourceMappingURL=CloseIcon.js.map